import { FIELDS } from '@/pages/PurchaseOrders/components/PurchaseOrderLines/constants';

const defaultFields = [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    key: 'id',
    field: FIELDS.ID,
    title: 'Line No',
    label: 'Line No',
    sortable: true,
    hidden: false,
    width: 75,
  },
  {
    key: 'purchaseOrderId',
    cell: 'navigation',
    field: FIELDS.PURCHASE_ORDER_ID,
    title: 'PO No',
    label: 'PO No',
    sortable: true,
    hidden: false,
    width: 75,
  },
  // {
  //   key: 'SalesOrderLineId',
  //   field: FIELDS.SALES_ORDER_LINE_ID,
  //   title: 'Sales Order Line Id',
  //   label: 'SalesOrderLineId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  // {
  //   key: 'RequirementLineId',
  //   field: FIELDS.REQUIREMENT_LINE_ID,
  //   title: 'Requirement Line Id',
  //   label: 'RequirementLineId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  // {
  //   key: 'RFPLineId',
  //   field: FIELDS.RFPLINE_ID,
  //   title: 'RFPLine Id',
  //   label: 'RFPLineId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'PODate',
    cell: 'formatDate',
    field: FIELDS.PODATE,
    title: 'PO Date',
    label: 'PO Date',
    sortable: true,
    hidden: false,
    width: 110,
  },
  // {
  //   key: 'CompanyId',
  //   field: FIELDS.COMPANY_ID,
  //   title: 'Company Id',
  //   label: 'CompanyId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: 'Company',
    label: 'Company',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'ContactId',
  //   field: FIELDS.CONTACT_ID,
  //   title: 'Contact Id',
  //   label: 'ContactId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'ContactFullName',
    field: FIELDS.CONTACT_FULL_NAME,
    title: 'Contact',
    label: 'Contact',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'StatusId',
  //   field: FIELDS.STATUS_ID,
  //   title: 'Status Id',
  //   label: 'StatusId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'StatusName',
    field: FIELDS.STATUS_NAME,
    title: 'Status',
    label: 'Status',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateDue',
    cell: 'formatDate',
    field: FIELDS.DATE_DUE,
    title: 'Date Due',
    label: 'Date Due',
    sortable: true,
    hidden: false,
    width: 110,
  },
  {
    key: 'DateShipped',
    field: FIELDS.DATE_SHIPPED,
    title: 'Date Shipped',
    label: 'Date Shipped',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DockDate',
    field: FIELDS.DOCK_DATE,
    title: 'Dock Date',
    label: 'Dock Date',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'ShippingMethodId',
  //   field: FIELDS.SHIPPING_METHOD_ID,
  //   title: 'Shipping Method Id',
  //   label: 'ShippingMethodId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  // {
  //   key: 'ShippingProviderId',
  //   field: FIELDS.SHIPPING_PROVIDER_ID,
  //   title: 'Shipping Provider Id',
  //   label: 'ShippingProviderId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'ShippingProviderName',
    field: FIELDS.SHIPPING_PROVIDER_NAME,
    title: 'Ship Via',
    label: 'Ship Via',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingMethodName',
    field: FIELDS.SHIPPING_METHOD_NAME,
    title: 'Ship Method',
    label: 'Ship Method',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingDays',
    field: FIELDS.SHIPPING_DAYS,
    title: 'Shipping Days',
    label: 'Shipping Days',
    sortable: true,
    hidden: false,
    width: 150,
   },
  // {
  //   key: 'PartId',
  //   field: FIELDS.PART_ID,
  //   title: 'Part Id',
  //   label: 'PartId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'PartNumber',
    field: FIELDS.PART_NUMBER,
    title: 'Part Number',
    label: 'Part Number',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AltNumber',
    field: FIELDS.ALT_NUMBER,
    title: 'Alt Number',
    label: 'Alt Number',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InternalPN',
    field: FIELDS.INTERNAL_PN,
    title: 'Internal PN',
    label: 'Internal PN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'NSNNumber',
    field: FIELDS.NSNNUMBER,
    title: 'NSN',
    label: 'NSN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SKU',
    field: FIELDS.SKU,
    title: 'SKU',
    label: 'SKU',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: 'Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'ManufacturerId',
  //   field: FIELDS.MANUFACTURER_ID,
  //   title: 'Manufacturer Id',
  //   label: 'ManufacturerId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'MfgName',
    field: FIELDS.MFG_NAME,
    title: 'Mfg',
    label: 'Mfg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'InventoryClassId',
  //   field: FIELDS.INVENTORY_CLASS_ID,
  //   title: 'Inventory Class Id',
  //   label: 'InventoryClassId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'ClassName',
    field: FIELDS.CLASS_NAME,
    title: 'Class',
    label: 'Class',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'InventoryCategoryId',
  //   field: FIELDS.INVENTORY_CATEGORY_ID,
  //   title: 'Inventory Category Id',
  //   label: 'InventoryCategoryId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'CategoryName',
    field: FIELDS.CATEGORY_NAME,
    title: 'Category',
    label: 'Category',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'PackageId',
  //   field: FIELDS.PACKAGE_ID,
  //   title: 'Package Id',
  //   label: 'PackageId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'Package',
    field: FIELDS.PACKAGE,
    title: 'Item Pkg',
    label: 'Item Pkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PiecePerPkg',
    field: FIELDS.PIECE_PER_PKG,
    title: 'SPQ',
    label: 'SPQ',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PhysPkg',
    field: FIELDS.PHYS_PKG,
    title: ' Phys Pkg',
    label: 'Phys Pkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadFree',
    field: FIELDS.LEAD_FREE,
    title: 'RoHS',
    label: 'RoHS',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TempRating',
    field: FIELDS.TEMP_RATING,
    title: 'Temp Rating',
    label: 'Temp Rating',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'UoMId',
  //   field: FIELDS.UO_MID,
  //   title: 'Uo MId',
  //   label: 'UoMId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'UOM',
    field: FIELDS.UOM,
    title: 'UOM',
    label: 'UOM',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: 'Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Quantity',
    field: FIELDS.QUANTITY,
    title: 'Quantity',
    label: 'Quantity',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Price',
    field: FIELDS.PRICE,
    title: 'Price',
    label: 'Price',
    cell: 'formatAmount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Total',
    field: FIELDS.TOTAL,
    title: 'Total',
    label: 'Total',
    cell: 'formatAmount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyAvailable',
    field: FIELDS.QTY_AVAILABLE,
    title: 'Available',
    label: 'Available',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyReceived',
    field: FIELDS.QTY_RECEIVED,
    title: 'Received',
    label: 'Received',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyRejected',
    field: FIELDS.QTY_REJECTED,
    title: 'Rejected',
    label: 'Rejected',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyRemaining',
    field: FIELDS.QTY_REMAINING,
    title: 'Remaining',
    label: 'Remaining',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConvertedPrice',
    field: FIELDS.CONVERTED_PRICE,
    title: 'Conv. Price',
    label: 'Conv. Price',
    cell: 'formatAmountConverted',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConvertedTotal',
    field: FIELDS.CONVERTED_TOTAL,
    title: 'Conv.Total',
    label: 'Conv. Total',
    cell: 'formatAmountConverted',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCode',
    field: FIELDS.DATE_CODE,
    title: 'Date Code',
    label: 'Date Code',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LotCode',
    field: FIELDS.LOT_CODE,
    title: 'Lot Code',
    label: 'Lot Code',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Revision',
    field: FIELDS.REVISION,
    title: 'Revision',
    label: 'Revision',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'ConditionId',
  //   field: FIELDS.CONDITION_ID,
  //   title: 'Condition Id',
  //   label: 'ConditionId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'ConditionName',
    field: FIELDS.CONDITION_NAME,
    title: 'Condition',
    label: 'Condition',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'CountryOfOriginId',
  //   field: FIELDS.COUNTRY_OF_ORIGIN_ID,
  //   title: 'Country Of Origin Id',
  //   label: 'CountryOfOriginId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'CountryOfOriginName',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
    title: 'COO',
    label: 'COO',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Tested',
    field: FIELDS.TESTED,
    title: 'Tested',
    label: 'Tested',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'CreatedByUserId',
  //   field: FIELDS.CREATED_BY_USER_ID,
  //   title: 'Created By User Id',
  //   label: 'CreatedByUserId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Created By',
    label: 'Created By',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'ModifiedByUserId',
  //   field: FIELDS.MODIFIED_BY_USER_ID,
  //   title: 'Modified By User Id',
  //   label: 'ModifiedByUserId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: 'Modified By',
    label: 'Modified By',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    cell: 'formatDate',
    field: FIELDS.DATE_CREATED,
    title: 'Date Created',
    label: 'Date Created',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    cell: 'formatDate',
    field: FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    label: 'Date Modified',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: 'Active',
    label: 'Active',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  // {
  //   key: 'isService',
  //   field: FIELDS.IS_SERVICE,
  //   title: 'Is Service',
  //   label: 'isService',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
]


export const addSourceOnOrderFields = [
  {
    key: 'id',
    field: FIELDS.ID,
    title: 'Line No',
    label: 'Line No',
    sortable: true,
    hidden: false,
    width: 75,
  },
  {
    key: 'purchaseOrderId',
    field: FIELDS.PURCHASE_ORDER_ID,
    title: 'PO No',
    label: 'PO No',
    sortable: true,
    hidden: false,
    width: 75,
  },
  {
    key: 'PODate',
    cell: 'formatDate',
    field: FIELDS.PODATE,
    title: 'PO Date',
    label: 'PO Date',
    sortable: true,
    hidden: false,
    width: 110,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: 'Company',
    label: 'Company',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ContactFullName',
    field: FIELDS.CONTACT_FULL_NAME,
    title: 'Contact',
    label: 'Contact',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'StatusName',
    field: FIELDS.STATUS_NAME,
    title: 'Status',
    label: 'Status',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateDue',
    cell: 'formatDate',
    field: FIELDS.DATE_DUE,
    title: 'Date Due',
    label: 'Date Due',
    sortable: true,
    hidden: false,
    width: 110,
  },
  {
    key: 'DateShipped',
    field: FIELDS.DATE_SHIPPED,
    title: 'Date Shipped',
    label: 'Date Shipped',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DockDate',
    field: FIELDS.DOCK_DATE,
    title: 'Dock Date',
    label: 'Dock Date',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingProviderName',
    field: FIELDS.SHIPPING_PROVIDER_NAME,
    title: 'Ship Via',
    label: 'Ship Via',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingMethodName',
    field: FIELDS.SHIPPING_METHOD_NAME,
    title: 'Ship Method',
    label: 'Ship Method',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingDays',
    field: FIELDS.SHIPPING_DAYS,
    title: 'Shipping Days',
    label: 'Shipping Days',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartNumber',
    field: FIELDS.PART_NUMBER,
    title: 'Part Number',
    label: 'Part Number',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AltNumber',
    field: FIELDS.ALT_NUMBER,
    title: 'Alt Number',
    label: 'Alt Number',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InternalPN',
    field: FIELDS.INTERNAL_PN,
    title: 'Internal PN',
    label: 'Internal PN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'NSNNumber',
    field: FIELDS.NSNNUMBER,
    title: 'NSN',
    label: 'NSN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SKU',
    field: FIELDS.SKU,
    title: 'SKU',
    label: 'SKU',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: 'Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'MfgName',
    field: FIELDS.MFG_NAME,
    title: 'Mfg',
    label: 'Mfg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ClassName',
    field: FIELDS.CLASS_NAME,
    title: 'Class',
    label: 'Class',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CategoryName',
    field: FIELDS.CATEGORY_NAME,
    title: 'Category',
    label: 'Category',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Package',
    field: FIELDS.PACKAGE,
    title: 'Item Pkg',
    label: 'Item Pkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PiecePerPkg',
    field: FIELDS.PIECE_PER_PKG,
    title: 'SPQ',
    label: 'SPQ',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PhysPkg',
    field: FIELDS.PHYS_PKG,
    title: ' Phys Pkg',
    label: 'Phys Pkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadFree',
    field: FIELDS.LEAD_FREE,
    title: 'RoHS',
    label: 'RoHS',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TempRating',
    field: FIELDS.TEMP_RATING,
    title: 'Temp Rating',
    label: 'Temp Rating',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UOM',
    field: FIELDS.UOM,
    title: 'UOM',
    label: 'UOM',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: 'Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Quantity',
    field: FIELDS.QUANTITY,
    title: 'Quantity',
    label: 'Quantity',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Price',
    field: FIELDS.PRICE,
    title: 'Price',
    label: 'Price',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Total',
    field: FIELDS.TOTAL,
    title: 'Total',
    label: 'Total',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyAvailable',
    field: FIELDS.QTY_AVAILABLE,
    title: 'Available',
    label: 'Available',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyReceived',
    field: FIELDS.QTY_RECEIVED,
    title: 'Received',
    label: 'Received',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyRejected',
    field: FIELDS.QTY_REJECTED,
    title: 'Rejected',
    label: 'Rejected',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyRemaining',
    field: FIELDS.QTY_REMAINING,
    title: 'Remaining',
    label: 'Remaining',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConvertedPrice',
    field: FIELDS.CONVERTED_PRICE,
    title: 'Conv. Price',
    label: 'Conv. Price',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConvertedTotal',
    field: FIELDS.CONVERTED_TOTAL,
    title: 'Conv.Total',
    label: 'Conv. Total',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCode',
    field: FIELDS.DATE_CODE,
    title: 'Date Code',
    label: 'Date Code',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LotCode',
    field: FIELDS.LOT_CODE,
    title: 'Lot Code',
    label: 'Lot Code',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Revision',
    field: FIELDS.REVISION,
    title: 'Revision',
    label: 'Revision',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConditionName',
    field: FIELDS.CONDITION_NAME,
    title: 'Condition',
    label: 'Condition',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CountryOfOriginName',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
    title: 'COO',
    label: 'COO',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Tested',
    field: FIELDS.TESTED,
    title: 'Tested',
    label: 'Tested',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Created By',
    label: 'Created By',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: 'Modified By',
    label: 'Modified By',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    cell: 'formatDate',
    field: FIELDS.DATE_CREATED,
    title: 'Date Created',
    label: 'Date Created',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    cell: 'formatDate',
    field: FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    label: 'Date Modified',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: 'Active',
    label: 'Active',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    title: ' ',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
